const appData = {
    title: "Handy Maps",
    description: [
        "Data makes a lot more sense when you can visualise it. Handy Maps lets you explore datasets in a visually appealing way.",
        "Explore datasets from institutions like the US Census Bureau, National Center for Education Statistics, US Department of Homeland Security, and others."
    ]
}

export default appData;